/* NR · Carrito — motor (Cart AJAX API + Section Rendering). NR-nativo, cero Empire.
   Contratos: abre con [data-nrc-abrir] · muta con data-nrc-mas/menos/eliminar (key en
   [data-nrc-linea]) · membresía [data-nrc-memb-add] · gancho [data-nrc-gancho].
   El estado de negocio (envío 1/2/3 · membresía E0-E2) lo decide LIQUID en cada render:
   este motor solo pide el HTML re-renderizado (sections=) y lo swapea.
   API pública: window.NRCart = { open, close, swap, refresh } (header Tanda 2 / ATC Tanda 2). */
(function () {
  'use strict';
  var SECTION = 'nr-cart-drawer';
  var PAGE_SECTION = 'nr-cart';
  var abierto = false;       /* fuente de verdad del estado del drawer (sobrevive swaps) */
  var disparador = null;

  function root() { return document.querySelector('[data-nr-cart]'); }
  function pagina() { return document.querySelector('[data-nr-cart-page]'); }
  function reducido() { return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches; }

  function sectionsParam() { return pagina() ? SECTION + ',' + PAGE_SECTION : SECTION; }

  /* ====== announcer aria-live PERSISTENTE (veredicto V8 Jul 6): una live-region que nace
     con el swap NO anuncia — esta vive fuera del HTML swapeado y el JS la actualiza ====== */
  /* la región nace AL CARGAR (una live-region recién creada se traga el primer anuncio
     en varios SR — code-review Jul 6); el script va defer → el body ya existe */
  var live = document.createElement('div');
  live.className = 'nrc-sr';
  live.setAttribute('aria-live', 'polite');
  document.body.appendChild(live);
  function anuncia(msg) {
    /* con el drawer abierto la región vive DENTRO del aria-modal (fuera, los SR la ignoran
       — code-review Jul 6); el swap reemplaza el panel → re-adjuntar en cada anuncio */
    var el = root();
    var destino = (abierto && el && el.querySelector('.nrcd__panel')) || document.body;
    if (live.parentNode !== destino) destino.appendChild(live);
    live.textContent = '';
    setTimeout(function () { live.textContent = msg; }, 50);
  }
  function anunciaCarrito(extra) {
    var host = (abierto && root()) || pagina() || root();
    if (!host) return;
    var sub = host.querySelector('[data-nrc-subtotal]');
    var n = parseInt((root() || {}).getAttribute ? root().getAttribute('data-nrc-count') : '', 10);
    var msg = '';
    if (sub) msg = 'Subtotal: ' + sub.textContent.trim();
    if (!isNaN(n)) msg += (msg ? ' · ' : '') + n + ' producto' + (n === 1 ? '' : 's');
    if (extra) msg = extra.replace(/\.\s*$/, '') + (msg ? '. ' + msg : '');
    if (msg) anuncia(msg);
  }

  /* ====== re-ancla de foco tras el swap (veredicto V8 Jul 6 — patrón del crawler, sesión F):
     el foco vuelve al control EQUIVALENTE (misma línea, mismo botón); fallback panel/página ====== */
  function capturaFoco() {
    var a = document.activeElement;
    if (!a || a === document.body) return null;
    var linea = a.closest && a.closest('[data-nrc-linea]');
    if (!linea) return null;
    var tipo = null;
    if (a.closest('[data-nrc-mas]')) tipo = 'mas';
    else if (a.closest('[data-nrc-menos]')) tipo = 'menos';
    else if (a.closest('[data-nrc-eliminar]')) tipo = 'eliminar';
    if (!tipo) return null;
    return { key: linea.getAttribute('data-nrc-linea'), tipo: tipo, enPagina: !a.closest('[data-nr-cart]') };
  }
  function reancla(ctx) {
    if (!ctx) return;
    var host = ctx.enPagina ? pagina() : root();
    if (!host) return;
    var el = host.querySelector('[data-nrc-linea="' + ctx.key + '"] [data-nrc-' + ctx.tipo + ']');
    if (!el && ctx.tipo !== 'eliminar') el = host.querySelector('[data-nrc-linea="' + ctx.key + '"] [data-nrc-eliminar]');
    if (!el) el = ctx.enPagina ? host : host.querySelector('.nrcd__x'); /* la línea murió (Eliminar) */
    if (el && el.focus) el.focus();
  }

  /* ====== cola de mutaciones + estado OCUPADO (pulido de respuesta, Jul 6 noche) ======
     El primer toque DESPACHA de inmediato (cero latencia añadida); los toques que caen
     mientras hay un request en vuelo solo mueven el TARGET (cantidad optimista pintada al
     instante) y al aterrizar se envía UN solo request con el destino final — mueren las
     peticiones redundantes y el «¿está pensando?»: la cantidad pulsa mientras viaja y
     Pagar/totales se atenúan (el monto podría estar viejo). Sin delays artificiales. */
  var cola = {};
  var enVuelo = 0;
  function ocupado(delta) {
    enVuelo = Math.max(0, enVuelo + delta);
    var on = enVuelo > 0;
    [root(), pagina()].forEach(function (h) {
      if (!h) return;
      h.classList.toggle('is-ocupado', on);
      if (on) h.setAttribute('aria-busy', 'true'); else h.removeAttribute('aria-busy');
    });
  }
  function pintaQty(key, valor, pendiente) {
    document.querySelectorAll('[data-nrc-linea="' + key + '"]').forEach(function (l) {
      l.classList.toggle('is-pend', !!pendiente);
      var qe = l.querySelector('[data-nrc-q]');
      if (qe && valor != null) { qe.setAttribute('data-nrc-q', valor); qe.lastChild.textContent = valor; }
    });
  }
  function programa(key, target) {
    var c = cola[key] || (cola[key] = { vuelo: false, target: null });
    c.target = target;
    pintaQty(key, target, true);
    if (!c.vuelo) despacha(key);
  }
  function despacha(key) {
    var c = cola[key];
    if (!c || c.vuelo) return;
    c.vuelo = true;
    var enviado = c.target;
    ocupado(1);
    mutar({ id: key, quantity: enviado }).then(function () {
      ocupado(-1);
      c.vuelo = false;
      if (cola[key] && cola[key].target !== enviado) { pintaQty(key, cola[key].target, true); despacha(key); }
      else { delete cola[key]; pintaQty(key, null, false); }
    });
  }

  function actualizarContador(n) {
    document.querySelectorAll('[data-nrh-cart-count]').forEach(function (el) {
      el.textContent = n;
      el.classList.toggle('is-visible', n > 0);
    });
  }

  /* swap del drawer: HTML nuevo SIN nrcd--anim → las mutaciones no re-deslizan el panel.
     El contador del header sale del data-nrc-count que Liquid hornea en el root (cero fetches). */
  function swap(html) {
    anotarCruce();
    var nuevo = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-nr-cart]');
    var actual = root();
    if (!nuevo || !actual) return;
    actual.replaceWith(nuevo);
    var n = parseInt(nuevo.getAttribute('data-nrc-count'), 10);
    if (!isNaN(n)) actualizarContador(n);
    pintarMembTodo();
    ocupado(0); /* el swap trae nodos frescos → re-aplicar is-ocupado si sigue habiendo vuelo */
    if (abierto) {
      nuevo.hidden = false;
      document.body.classList.add('nrcd-open');
      /* el nodo enfocado murió con el swap → el foco cayó a <body>; re-anclar al panel */
      if (document.activeElement === document.body) {
        var x = nuevo.querySelector('.nrcd__x');
        if (x) x.focus();
      }
    }
  }

  function swapPagina(html) {
    anotarCruce();
    var nuevo = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-nr-cart-page]');
    var actual = pagina();
    if (nuevo && actual) { actual.replaceWith(nuevo); pintarMembTodo(); ocupado(0); }
  }

  /* ── EL SELLO · el cruce del umbral de envío (dirección B, Jul 27) ──────────────
     El estado lo decide Liquid en cada render, así que el motor no calcula nada:
     solo mira el objeto ANTES del swap y, si pasó a «logrado» viniendo de otro
     estado, marca los nodos nuevos para que el CSS estampe el check UNA vez.
     Reglas del veredicto: se celebra el cruce real, nunca la vuelta atrás (perder
     el envío gratis no se subraya) ni un carrito que ya llegaba logrado. Si antes
     no había objeto (carrito vacío) tampoco se sella: no hubo recorrido que ver. */
  var cruceAntes = null, cruceEnCurso = false, cruceTimer = 0;

  function envioAntes() {
    var el = document.querySelector('[data-nrc-envio]');
    if (!el) return null;
    var barra = el.querySelector('.nrc-barp > i');
    return {
      logrado: el.classList.contains('nrc-obj--vd'),
      pct: (barra && barra.style.width) || '0%'
    };
  }

  /* Se anota al ENTRAR a cualquier swap (por eso vive en swap/swapPagina y no en
     swapTodo: el ATC del PDP y el de la membresía llaman a NRCart.swap directo).
     Los swaps de un mismo tick —drawer y página— comparten UNA sola captura, y el
     sellado corre en el tick siguiente, cuando ya aterrizaron los dos. */
  function anotarCruce() {
    if (cruceEnCurso) return;
    cruceEnCurso = true;
    cruceAntes = envioAntes();
    setTimeout(function () {
      sellarCruce(cruceAntes);
      cruceAntes = null; cruceEnCurso = false;
    }, 0);
  }

  function sellarCruce(antes) {
    if (!antes || antes.logrado || reducido()) return;
    var sellados = [];
    document.querySelectorAll('[data-nrc-envio]').forEach(function (el) {
      if (!el.classList.contains('nrc-obj--vd')) return;
      /* el drawer cerrado es display:none y ahí las animaciones no corren: sellarlo
         lo dejaría ARMADO y estrenaría el sello entero al abrirlo un minuto después,
         sin que nada hubiera cruzado. Solo se sella lo que el cliente está viendo. */
      if (!el.getClientRects().length) return;
      el.style.setProperty('--nrc-cruce-desde', antes.pct); /* remata desde donde estaba */
      el.classList.add('is-cruce');
      sellados.push(el);
    });
    if (!sellados.length) return;
    document.body.classList.add('nrc-sello'); /* eco en el candado de Pagar */
    clearTimeout(cruceTimer); /* dos cruces seguidos: el 2º manda, no lo apaga el 1º */
    cruceTimer = setTimeout(function () {
      document.body.classList.remove('nrc-sello');
      sellados.forEach(function (el) {
        el.classList.remove('is-cruce');
        el.style.removeProperty('--nrc-cruce-desde');
      });
    }, 1400);
  }

  function swapTodo(sections) {
    if (!sections) return;
    if (sections[SECTION]) swap(sections[SECTION]);
    if (sections[PAGE_SECTION]) swapPagina(sections[PAGE_SECTION]);
  }

  function error(msg) {
    var zona = (abierto && root()) || pagina() || root();
    var el = zona ? zona.querySelector('[data-nrc-error]') : null;
    if (!el) return;
    el.textContent = msg || 'No se pudo actualizar el carrito. Intenta de nuevo.';
    el.hidden = false;
    setTimeout(function () { el.hidden = true; }, 6000);
  }

  function mutar(body) {
    var ctx = capturaFoco();
    var pedida = body.quantity;
    body.sections = sectionsParam();
    return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) {
          var d = res.j && (res.j.description || res.j.message);
          /* tope de inventario (V13 Jul 6): con la línea YA al máximo el server RECHAZA (422,
             «Debido a la disponibilidad…») — la señal va junto al stepper, no arriba */
          if (body.id && pedida > 1 && d) {
            var max = pedida - 1;
            var txtMax = 'Solo hay ' + max + (max === 1 ? ' disponible.' : ' disponibles.');
            var hints = document.querySelectorAll('[data-nrc-linea="' + body.id + '"] [data-nrc-linea-hint]');
            if (hints.length) {
              hints.forEach(function (h) { h.textContent = txtMax; h.hidden = false; });
              anuncia(txtMax);
              /* el rechazo no swapea → revertir la cantidad optimista al máximo real */
              pintaQty(body.id, max, false);
              if (cola[body.id]) cola[body.id].target = max;
              return res.j;
            }
          }
          if (body.id) {
            pintaQty(body.id, null, false); /* sin swap: apagar el pulso */
            document.querySelectorAll('[data-nrc-linea="' + body.id + '"]').forEach(function (l) { l.classList.remove('is-borrando'); });
          }
          error(d);
          return res.j;
        }
        swapTodo(res.j.sections);
        reancla(ctx);
        /* hint de inventario (veredicto V13 Jul 6): change.js recorta EN SILENCIO al stock
           (R-19) — si volvió menos de lo pedido, se dice honesto junto al stepper */
        var recorte = null;
        if (pedida > 0 && res.j && res.j.items) {
          var it = res.j.items.find(function (x) { return x.key === body.id; });
          if (it && it.quantity < pedida) recorte = it.quantity;
        }
        if (recorte !== null) {
          var txtRecorte = 'Solo hay ' + recorte + (recorte === 1 ? ' disponible.' : ' disponibles.');
          document.querySelectorAll('[data-nrc-linea="' + body.id + '"] [data-nrc-linea-hint]').forEach(function (h) {
            h.textContent = txtRecorte;
            h.hidden = false;
          });
          anunciaCarrito(txtRecorte);
        } else {
          anunciaCarrito();
        }
        return res.j;
      })
      .catch(function () {
        if (body.id) {
          pintaQty(body.id, null, false);
          document.querySelectorAll('[data-nrc-linea="' + body.id + '"]').forEach(function (l) { l.classList.remove('is-borrando'); });
        }
        error();
      });
  }

  function open(desde) {
    var el = root();
    if (!el) return;
    disparador = (desde && desde.focus) ? desde : document.activeElement;
    abierto = true;
    el.classList.add('nrcd--anim'); /* entra deslizando SOLO al abrir */
    el.hidden = false;
    document.body.classList.add('nrcd-open');
    var x = el.querySelector('.nrcd__x');
    if (x) x.focus();
  }

  function close() {
    var el = root();
    if (!el) return;
    abierto = false;
    el.hidden = true;
    el.classList.remove('nrcd--anim');
    document.body.classList.remove('nrcd-open');
    if (disparador && disparador.focus && document.contains(disparador)) disparador.focus();
    disparador = null;
  }

  /* ====== membresía: disponibilidad CRUZADA de los chips (patrón del selector de tallas
     del PDP): un valor queda is-agotada si NINGUNA variante disponible lo combina con lo
     ya elegido en los OTROS grupos. El agotado global viene marcado del server (Liquid). */
  function pintarDisponibilidadMemb(caja) {
    var form = caja.querySelector('[data-nrc-memb-form]');
    var dataEl = caja.querySelector('[data-nrc-memb-variantes]');
    if (!form || !dataEl) return;
    var variantes;
    try { variantes = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var grupos = Array.prototype.slice.call(form.querySelectorAll('.nrc-memb__opt'));
    /* 2 pasadas: si la 1ª des-selecciona un valor que quedó agotado, la 2ª repinta con la selección nueva */
    for (var pasada = 0; pasada < 2; pasada++) {
      var sel = grupos.map(function (g) { var m = g.querySelector('input:checked'); return m ? m.value : null; });
      grupos.forEach(function (g, i) {
        g.querySelectorAll('.nrc-chip').forEach(function (chip) {
          var input = chip.querySelector('input');
          var ok = variantes.some(function (x) {
            if (x.available === false) return false;
            var opts = [x.option1, x.option2, x.option3];
            if (opts[i] !== input.value) return false;
            for (var j = 0; j < grupos.length; j++) {
              if (j !== i && sel[j] != null && opts[j] !== sel[j]) return false;
            }
            return true;
          });
          chip.classList.toggle('is-agotada', !ok);
          input.disabled = !ok;
          if (!ok && input.checked) input.checked = false;
        });
      });
    }
    /* botón CONTEXTUAL (patrón ATC del PDP): negro solo con la selección completa */
    var btn = caja.querySelector('[data-nrc-memb-add]');
    if (btn) {
      var completo = grupos.every(function (g) { return !!g.querySelector('input:checked'); });
      btn.disabled = !completo;
      btn.classList.toggle('is-off', !completo);
      if (completo) { var hint = caja.querySelector('[data-nrc-memb-hint]'); if (hint) hint.hidden = true; }
    }
  }
  function pintarMembTodo() {
    document.querySelectorAll('[data-nrc-memb]').forEach(pintarDisponibilidadMemb);
  }
  /* PODA F5 (Jul 27): aquí vivía `abrirMemb()`, que desplegaba la maquinaria de la membresía.
     Murió con «la espina del objeto»: los selectores pasaron a estar SIEMPRE visibles, así que
     `[data-nrc-memb-exp]` dejó de existir y la función era un no-op absoluto (se salía en su
     propia guarda). Con ella caen `membAbierta` y sus tres puntos de llamada. Recuperable en git. */
  document.addEventListener('change', function (e) {
    var caja = e.target.closest && e.target.closest('[data-nrc-memb]');
    if (caja) pintarDisponibilidadMemb(caja);
  });

  /* ====== membresía: 3 radios → variante del JSON inline → /cart/add.js ====== */
  function agregarMembresia(btn) {
    var caja = btn.closest('[data-nrc-memb]');
    if (!caja) return;
    var form = caja.querySelector('[data-nrc-memb-form]');
    var dataEl = caja.querySelector('[data-nrc-memb-variantes]');
    var hint = caja.querySelector('[data-nrc-memb-hint]');
    if (!form || !dataEl) return;
    var muestraHint = function (txt) { if (hint) { if (txt) hint.textContent = txt; hint.hidden = false; } };
    var grupos = form.querySelectorAll('.nrc-memb__opt');
    var sel = [];
    var completo = true;
    grupos.forEach(function (g, i) {
      var m = g.querySelector('input:checked');
      if (m) sel[i] = m.value; else completo = false;
    });
    if (!completo) { muestraHint(); return; }
    if (hint) hint.hidden = true;
    var variantes;
    try { variantes = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var v = variantes.find(function (x) {
      return (sel[0] == null || x.option1 === sel[0]) && (sel[1] == null || x.option2 === sel[1]) && (sel[2] == null || x.option3 === sel[2]);
    });
    if (!v) { muestraHint('Esa combinación no está disponible.'); return; }
    if (v.available === false) { muestraHint('Esa combinación está agotada por ahora.'); return; }
    btn.disabled = true;
    var txtBtn = btn.textContent;
    btn.textContent = 'Agregando…'; /* mismo patrón del ATC del PDP: el botón dice que está pensando */
    btn.classList.add('is-cargando');
    ocupado(1);
    var reponBtn = function () { btn.disabled = false; btn.textContent = txtBtn; btn.classList.remove('is-cargando'); };
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }], sections: sectionsParam() }) })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        ocupado(-1);
        if (!res.ok) { reponBtn(); muestraHint((res.j && res.j.description) || 'No se pudo agregar. Intenta de nuevo.'); return; }
        swapTodo(res.j.sections); /* el botón muere con el swap (llega E2) */
        anunciaCarrito('Membresía agregada');
      })
      .catch(function () { ocupado(-1); reponBtn(); muestraHint('No se pudo agregar. Intenta de nuevo.'); });
  }

  /* PODA F5 (Jul 27): aquí vivía `estimar()`, la consulta de tarifas por departamento
     (/cart/shipping_rates.json + fallback prepare/poll). Murió con «la espina del objeto»:
     solo hay 2 tarifas en Colombia, así que se ESCRIBEN en nr-cart-totales en vez de
     calcularse. Con ella cae `money()`, que no tenía otro consumidor. Recuperable en git. */

  /* ====== interacción: delegación única a nivel documento (sobrevive los swaps) ====== */
  document.addEventListener('click', function (e) {
    var abrir = e.target.closest('[data-nrc-abrir]');
    if (abrir) { e.preventDefault(); open(abrir); return; }
    if (e.target.closest('[data-nrc-close]')) { close(); return; }
    var linea = e.target.closest('[data-nrc-linea]');
    if (linea) {
      var key = linea.getAttribute('data-nrc-linea');
      /* contrato por data-attr (code-review Jul 6); fallback a los dígitos del texto
         (cubre la ventana HTML-viejo + JS-nuevo al publicar) */
      var qEl = linea.querySelector('[data-nrc-q]') || linea.querySelector('.nrc-step__q');
      var q = qEl ? parseInt(qEl.getAttribute('data-nrc-q') || (qEl.textContent || '').replace(/\D/g, ''), 10) : 1;
      if (isNaN(q) || q < 1) q = 1;
      /* base = el target pendiente si hay uno en vuelo (toques rápidos acumulan) */
      var base = (cola[key] && cola[key].target != null) ? cola[key].target : q;
      if (e.target.closest('[data-nrc-mas]')) { programa(key, base + 1); return; }
      if (e.target.closest('[data-nrc-menos]')) {
        if (base - 1 <= 0) { linea.classList.add('is-borrando'); ocupado(1); mutar({ id: key, quantity: 0 }).then(function () { ocupado(-1); }); }
        else programa(key, base - 1);
        return;
      }
      if (e.target.closest('[data-nrc-eliminar]')) { linea.classList.add('is-borrando'); ocupado(1); mutar({ id: key, quantity: 0 }).then(function () { ocupado(-1); }); return; }
    }
    if (e.target.closest('[data-nrc-gancho]')) {
      var host = root(); /* el gancho solo existe en el pie del drawer (m13: murió el fallback a página) */
      var m = host ? host.querySelector('[data-nrc-memb]') : null;
      if (m) {
        m.scrollIntoView({ behavior: reducido() ? 'auto' : 'smooth', block: 'center' });
        /* el destello lo pinta `.nrc-memb.is-resaltado .nrc-obj` (nr-cart-css) */
        m.classList.add('is-resaltado');
        setTimeout(function () { m.classList.remove('is-resaltado'); }, 1400);
      }
      return;
    }
    var membAdd = e.target.closest('[data-nrc-memb-add]');
    if (membAdd) { agregarMembresia(membAdd); return; }
    /* PODA F5 (Jul 27): aquí vivían los handlers de [data-nrc-memb-abrir], [data-nrc-est-abrir]
       y [data-nrc-estimar] — los tres disparadores del colapso. Ninguno de esos atributos existe
       ya en el markup: los colapsables murieron con «la espina del objeto». Recuperable en git. */
  });

  /* Escape + focus trap (patrón H7 del quiz + regla R-17: a[href] estricto + filtro de
     visibilidad — un [href] a secas matchea los <use href="#nr-…"> y el trap nunca envuelve) */
  document.addEventListener('keydown', function (e) {
    var el = root();
    if (!el || el.hidden) return;
    if (e.key === 'Escape') { close(); return; }
    if (e.key !== 'Tab') return;
    var pan = el.querySelector('.nrcd__panel');
    if (!pan) return;
    var all = pan.querySelectorAll('a[href], button, input, select, textarea, summary, [tabindex]:not([tabindex="-1"])');
    var vivos = [];
    all.forEach(function (n) {
      if (n.disabled) return;
      if (n.tabIndex === -1) return;
      if (n.closest('[hidden]')) return;
      if (!n.getClientRects().length) return;
      vivos.push(n);
    });
    if (!vivos.length) return;
    var first = vivos[0];
    var last = vivos[vivos.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    else if (!pan.contains(document.activeElement)) { e.preventDefault(); first.focus(); }
  });

  /* swap público (lo usa el ATC del PDP): además del HTML, refresca el contador del header */
  window.NRCart = { open: open, close: close, swap: swap, refresh: swapTodo };

  pintarMembTodo(); /* disponibilidad inicial de los chips (drawer y /cart; defer = DOM listo) */
})();
